/** Maximum file upload size in megabytes. */
export const MAX_FILE_UPLOAD_SIZE_MB = 1024;

/** Maximum file upload size in bytes (derived from MB value). */
export const MAX_FILE_UPLOAD_SIZE_BYTES = MAX_FILE_UPLOAD_SIZE_MB * 1024 * 1024;

/**
 * Max number of concurrent StartAsyncIngestFile RPCs a single browser tab will keep in
 * flight when bulk-dispatching page ingestion (Issue #1593). Kept well under the point where
 * Chromium starts failing outstanding fetches with net::ERR_INSUFFICIENT_RESOURCES on
 * multi-hundred-page files.
 */
export const BULK_INGESTION_DISPATCH_CONCURRENCY = 20;
